export type ConversationStartersContext =
  | { type: 'recruitment_general' }
  | {
      type: 'recruitment_candidate';
      params: { candidateId: number; candidateName: string };
    }
  | {
      type: 'recruitment_job';
      params: { jobId: number; jobTitle: string };
    };

export interface ConversationStarterMessage {
  role: 'system' | 'user';
  content: string;
}

export interface ConversationStarter {
  id: string;
  source: string;
  definitionKey: string;
  skill: string | null;
  text: string;
  messages: readonly ConversationStarterMessage[];
  priority: number;
}

export interface ConversationStarters {
  type: ConversationStartersContext['type'];
  prompt: string;
  conversationStarters: readonly ConversationStarter[];
}

export const conversationStartersKey = (ctx: ConversationStartersContext): string => {
  switch (ctx.type) {
    case 'recruitment_candidate':
      return `${ctx.type}:${ctx.params.candidateId}`;
    case 'recruitment_job':
      return `${ctx.type}:${ctx.params.jobId}`;
    default:
      return ctx.type;
  }
};
